/**
 * Initialize Changelog with the privacy email change
 * This should be called once to log the email address changes
 */

import { logChange } from './changeLogger';

export const initializeChangelogWithEmailUpdate = () => {
  // Check if this change was already logged
  const alreadyLogged = localStorage.getItem('email-change-logged');
  
  if (!alreadyLogged) {
    logChange(
      'datenschutz',
      'Datenschutz-E-Mail-Adresse aktualisiert',
      'Alle datenschutzbezogenen E-Mail-Adressen wurden von office@eap-abutments.com auf datenschutz@eap-abutments.com geändert',
      {
        betroffeneDateien: [
          'src/pages/Datenschutz.tsx',
          'src/pages/AdminBetroffenenrechte.tsx',
          'src/components/StructuredData.tsx'
        ],
        alteEmail: 'office@eap-abutments.com',
        neueEmail: 'datenschutz@eap-abutments.com',
        anzahlAenderungen: 10,
        grund: 'DSGVO-Compliance: Separate E-Mail-Adresse für Datenschutzanfragen'
      }
    );
    
    localStorage.setItem('email-change-logged', 'true');
  }
};
